export default {
  'pages.setting.user.title': '用户管理',
  'pages.setting.user.subtitle': '管理系统用户账号、角色和权限',
  'pages.setting.user.searchPlaceholder': '搜索用户名、姓名或邮箱',
  'pages.setting.user.export': '导出',
  'pages.setting.user.exportFileName': '用户数据',
  // 表格列
  'pages.setting.user.column.id': '用户ID',
  'pages.setting.user.column.userName': '用户名',
  'pages.setting.user.column.nickName': '真实姓名',
  'pages.setting.user.column.email': '邮箱',
  'pages.setting.user.column.phone': '手机号',
  'pages.setting.user.column.role': '角色',
  'pages.setting.user.column.department': '部门',
  'pages.setting.user.column.status': '状态',
  'pages.setting.user.column.lastLoginTime': '最后登录时间',
  'pages.setting.user.column.operation': '操作',
  // 状态
  'pages.setting.user.status.enabled': '启用',
  'pages.setting.user.status.disabled': '禁用',
  // 操作
  'pages.setting.user.resetPassword': '重置密码',
  'pages.setting.user.resetPasswordConfirm': '确定重置密码？',
  'pages.setting.user.add': '新增用户',
  'pages.setting.user.edit': '编辑',
  // 弹窗标题
  'pages.setting.user.modal.addTitle': '新增用户',
  'pages.setting.user.modal.editTitle': '编辑用户',
  // 表单
  'pages.setting.user.form.userName': '用户名',
  'pages.setting.user.form.userNamePlaceholder': '请输入用户名',
  'pages.setting.user.form.userNameRequired': '请输入用户名',
  'pages.setting.user.form.userNameLength': '用户名长度为4-20个字符',
  'pages.setting.user.form.userNamePattern': '用户名只能包含字母、数字、下划线',
  'pages.setting.user.form.nickName': '真实姓名',
  'pages.setting.user.form.nickNamePlaceholder': '请输入真实姓名',
  'pages.setting.user.form.nickNameRequired': '请输入真实姓名',
  'pages.setting.user.form.email': '邮箱',
  'pages.setting.user.form.emailPlaceholder': '请输入邮箱地址',
  'pages.setting.user.form.emailRequired': '请输入邮箱地址',
  'pages.setting.user.form.emailInvalid': '请输入正确的邮箱格式',
  'pages.setting.user.form.phone': '手机号',
  'pages.setting.user.form.phonePlaceholder': '请输入手机号',
  'pages.setting.user.form.phoneRequired': '请输入手机号',
  'pages.setting.user.form.phoneInvalid': '请输入正确的菲律宾手机号',
  'pages.setting.user.form.department': '部门',
  'pages.setting.user.form.departmentPlaceholder': '请选择所属部门',
  'pages.setting.user.form.departmentRequired': '请选择所属部门',
  'pages.setting.user.form.sex': '性别',
  'pages.setting.user.form.sexPlaceholder': '请选择性别',
  'pages.setting.user.form.sexMale': '男',
  'pages.setting.user.form.sexFemale': '女',
  'pages.setting.user.form.role': '角色',
  'pages.setting.user.form.rolePlaceholder': '请选择角色',
  'pages.setting.user.form.roleRequired': '请选择角色',
  'pages.setting.user.form.status': '状态',
  'pages.setting.user.form.password': '密码',
  'pages.setting.user.form.passwordPlaceholder': '请输入6-20位字母与数字组合',
  'pages.setting.user.form.passwordRequired': '请输入密码',
  'pages.setting.user.form.passwordPattern':
    '密码需为6-20位，且必须包含字母和数字',
  'pages.setting.user.form.remark': '备注',
  'pages.setting.user.form.remarkPlaceholder': '请输入备注信息',
  // 提示消息
  'pages.setting.user.message.updateStatusSuccess': '更新状态成功',
  'pages.setting.user.message.resetSuccess': '重置成功',
  'pages.setting.user.message.deleteSuccess': '删除成功',
  'pages.setting.user.message.selectAtLeastOne': '请至少选择一项',
  'pages.setting.user.message.addSuccess': '新增成功',
  'pages.setting.user.message.editSuccess': '编辑成功',
  'pages.setting.user.message.exportCount': '导出 {count} 个用户',
  'pages.setting.user.message.exportSuccess': '导出成功',
  'pages.setting.user.message.exportFailed': '导出失败，请重试',
};
